import { useStore } from "../context/StoreContext";

export const Marquee = () => {
  const { L } = useStore();
  const items = L.marquee.items;
  return (
    <div className="relative py-8 border-y border-gold/15 overflow-hidden" data-testid="editorial-marquee">
      <div className="flex w-max marquee-track">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex items-center shrink-0">
            {items.map((it, i) => (
              <span key={copy + "-" + i} className="flex items-center">
                <span className="font-display text-2xl md:text-4xl text-transparent px-6 whitespace-nowrap" style={{ WebkitTextStroke: "1px rgba(212,175,55,0.55)" }}>
                  {it}
                </span>
                <span className="text-gold text-lg" aria-hidden="true">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
